import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { ServiceMetricsDataType } from '@/models/statistic';

export const fetchServiceMetricsData = async (): Promise<ServiceMetricsDataType[]> => {
  const response = await queryExecute({
    query: graphql(`
      query ServiceMetricsData {
        serviceMetricsData {
          index
          count
          rideCount
          groceryCount
          mealCount
          dataType
        }
      }
    `),
    fetchPolicy: 'no-cache',
  });

  return response.data.serviceMetricsData ?? [];
};
